import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'app-components';

import { ModalContextType } from '../../../contexts/modalContext';
import { ConditionalRendering } from '../../../components/common/conditional-rendering';
import CapitalizedButton from '../components/common/CapitalizedButton';

interface IModalProps extends ModalContextType {
    multiGroupFailureChangeRecommended: boolean;
    multiGroupFailureChangeRecommendedNativeAmerican: boolean;
    multiGroupFailureNonStandardNotAllowed: boolean;
    multiGroupFailureOverageMember: boolean;
    multiGroupFailureNotAllowed: boolean;
    onContinue: Function;
}

export default function FailsToFormMultiCustomgroupModal(props: IModalProps) {
    const {
        multiGroupFailureChangeRecommended,
        multiGroupFailureNonStandardNotAllowed,
        multiGroupFailureOverageMember,
        multiGroupFailureChangeRecommendedNativeAmerican,
        multiGroupFailureNotAllowed,
        closeModal,
        onContinue,
    } = props;

    const customGroupingErrorTexts = [
        {
            id: 'changeRecommendedBodyText',
            condition:
                multiGroupFailureChangeRecommended &&
                !multiGroupFailureNonStandardNotAllowed &&
                !multiGroupFailureOverageMember,
            text: 'customGrouping.error.changeRecommended',
        },
        {
            id: 'changeRecommendedNativeAmericanBodyText',
            condition:
                multiGroupFailureChangeRecommendedNativeAmerican &&
                !multiGroupFailureNonStandardNotAllowed &&
                !multiGroupFailureOverageMember,
            text: 'customGrouping.error.changeRecommendedNativeAmerican',
        },
        {
            id: 'enrollBodyText',
            condition:
                multiGroupFailureNotAllowed &&
                !multiGroupFailureChangeRecommended &&
                !multiGroupFailureChangeRecommendedNativeAmerican &&
                !multiGroupFailureOverageMember,
            text: 'customGrouping.error.enroll',
        },
        {
            id: 'nonStandardGroupEnrollBodyText',
            condition:
                multiGroupFailureNonStandardNotAllowed &&
                !multiGroupFailureNotAllowed &&
                !multiGroupFailureOverageMember,
            text: 'customGrouping.error.nonStandardGroupEnroll',
        },
        {
            id: 'proceedBodyText',
            condition:
                !multiGroupFailureNonStandardNotAllowed &&
                !multiGroupFailureNotAllowed &&
                !multiGroupFailureOverageMember,
            text: 'customGrouping.error.proceed',
        },
        {
            id: 'overageMemberBodyText',
            condition: multiGroupFailureOverageMember,
            text: 'customGrouping.error.overageMember',
        },
    ];

    function onClose(e) {
        e?.preventDefault();
        closeModal('failToFormMultiCustomGroup');
    };

    function onNext(e) {
        onContinue();
        onClose(e);
    }

    return (
        <Modal id="failsToFormMultiCustomgroupModal">
            <Modal.Header
                id="failsToFormMultiCustomgroupModalHeader"
                titleId="customGrouping.customGrouping"
                onHide={onClose}
            />
            <Modal.Body id="failsToFormMultiCustomgroupModalBody">
                <>
                    {customGroupingErrorTexts.map((config, index) => (
                        <ConditionalRendering isTrue={config.condition} key={index}>
                            <p key={index} data-testid={config.id}>
                                <FormattedMessage id={config.text} />
                            </p>
                        </ConditionalRendering>
                    ))}
                </>
            </Modal.Body>
            <Modal.Controls>
                <ConditionalRendering
                    isTrue={
                        !multiGroupFailureNotAllowed &&
                        !multiGroupFailureNonStandardNotAllowed &&
                        !multiGroupFailureOverageMember
                    }
                >
                    <CapitalizedButton
                        id="failsToFormMultiCustomgroupModalCancelButton"
                        onClickHandler={onClose}
                        variant="secondary"
                        labelId="button.cancel"
                    />
                    <CapitalizedButton
                        id="failsToFormMultiCustomgroupModalContinueButton"
                        onClickHandler={onNext}
                        variant="primary"
                        labelId="customGrouping.continue"
                        leftMargin={true}
                    />
                </ConditionalRendering>
                <ConditionalRendering
                    isTrue={
                        multiGroupFailureNotAllowed ||
                        multiGroupFailureNonStandardNotAllowed ||
                        multiGroupFailureOverageMember
                    }
                >
                    <CapitalizedButton
                        id="failsToFormMultiCustomgroupModalContinueButton"
                        onClickHandler={onClose}
                        variant="primary"
                        labelId="customGrouping.continue"
                        leftMargin={true}
                    />
                </ConditionalRendering>
            </Modal.Controls>
        </Modal>
    );
}
